import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { MOBILE_BREAKPOINT } from 'theme'

/**
 * Use consistent breakpoints across Layout options and inside components, to make sure we never end up with an
 * iPad implementing the desktop version of a component.
 *
 * WARNING: specify we're not using server-side rendering to avoid a double-rendering.
 * Indeed, the behavior otherwise is to first return `false` as a temporary default, then the accurate value.
 * @see https://github.com/mui/material-ui/issues/21142#issuecomment-633144987
 */
export default function useIsDesktop() {
    const theme = useTheme()
    return useMediaQuery(theme.breakpoints.up(MOBILE_BREAKPOINT), { noSsr: true })
}
